import React from 'react';

import Footer from '../../components/footer/Footer';
import Navbar from '../../components/navbar/Navbar';

type Props = {
  id: string;
};

const Contact: React.FC<Props> = (props) => {
  return (
    <div id={props.id} data-testid={props.id}>
      <Navbar id="navbar" />
      <h1>CONTACT</h1>
      <Footer id="footer" />
    </div>
  );
};

export default Contact;
